import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { t } from "i18next";

export const SharesList = ({ shares }) => {
    const formatPct = (s) => {
        if (s === undefined || s === null) {
            return "-";
        }
        const n = typeof s === "string" ? Number.parseFloat(s) : s;
        if (!Number.isFinite(n)) {
            return "-";
        }
        const fmt = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });
        return `${fmt.format(n)}%`;
    };

    const namesForShare = (share) =>
        (share.customers || [])
            .map((c) => {
                const p = c.person;
                if (!p) {
                    return c.company?.name ?? c.id;
                }
                return [p.name, p.name2, p.surname].filter(Boolean).join(" ");
            })
            .join(", ");

    if (!shares || shares.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                {t("agreements.SharesList.noSharesDefined")}
            </Typography>
        );
    }

    return (
        <TableContainer component={Paper} variant="outlined" sx={{ mb: 2 }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography variant="subtitle2">
                                {t("agreements.SharesList.sharesTitle")}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="subtitle2">
                                {t("agreements.SharesList.share")}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {shares.map((sh) => (
                        <TableRow key={sh.id}>
                            <TableCell>{namesForShare(sh)}</TableCell>
                            <TableCell>{formatPct(sh.percentage)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
